<template>
  <v-row align="start" justify="center" dense>
    <v-col class="content">
      <v-card>
        <v-form ref="form" v-model="form">
          <v-tabs
            color="deep-purple accent-4"
            left>
            <v-tab> Клиенты и материалы </v-tab>
            <v-tab-item>
              <v-container>
                <!--              <v-form ref="form" v-model="form">-->
                <div v-if="reportInfo" class="text-overline mb-4">
                  <span v-if="reportInfo.project">{{ reportInfo.project.name }};</span>
                  {{ reportInfo.date }};
                  <span v-if="reportInfo.place">{{ reportInfo.place.name }};</span>
                  <span v-if="reportInfo.hours">{{ reportInfo.hours }} часа;</span>
                  {{ reportInfo.users }}
                </div>
                <template v-for="(customer, index) in customers">
                  <v-row align="center" justify="center">
                    <v-col
                      :key="index"
                      :class="index === (customers.length-1) ? '' : 'col-12'"
                      class="flex-md-grow-1 flex-md-shrink-0 py-0 my-0">
                      <customers-combo-box
                        :ref="`combo-${index}`"

                        :value.sync="customers[index]"
                        :education.sync="customerEducation"
                        :is-treatment.sync="customerTreatment"
                        :prev-tests-result.sync="prevTestsResult"
                        :customer-groups.sync="customerGroups"
                        :to-rename.sync="toRename"
                        :multiple="false"
                        :selected-val="customers[index]"
                        @addCustomer="addCustomer()"
                        @clear="onClear(index)" />
                    </v-col>
                  </v-row>
                  <!--                  <v-row align="center" justify="center">-->
                  <!--                    <v-col cols="12" class="py-0">-->
                  <!--                      <v-col>-->
                  <!--                        <h4>Группы</h4>-->
                  <!--                      </v-col>-->
                  <!--                      <v-row class="py-0">-->
                  <!--                        <v-col v-for="group in customerGroupsList"-->
                  <!--                               :key="group.value"-->
                  <!--                               cols="12"-->
                  <!--                               lg="2"-->
                  <!--                               class="py-0">-->
                  <!--                          <v-checkbox v-model="customerGroups"-->
                  <!--                                      :value="group"-->
                  <!--                                      :label="group.name" />-->
                  <!--                        </v-col>-->
                  <!--                      </v-row>-->
                  <!--                    </v-col>-->
                  <!--                  </v-row>-->
                  <v-row>
                    <v-col cols="12">
                      <v-expansion-panels>
                        <v-expansion-panel :ref="`panel-${index}`">
                          <v-expansion-panel-header>
                            <h4>Консультации</h4>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content class="py-0 my-0">
                            <v-row>
                              <v-col v-for="consult in consultListItems"
                                     :key="consult.value"
                                     cols="12"
                                     class="py-0 my-0"
                                     lg="6">
                                <v-checkbox
                                  :ref="`checkbox-${customers[index]}--${consult.name}`"
                                  :label="consult.name"
                                  :disabled="!customers[index]"
                                  :false-value="0"
                                  :true-value="1"
                                  :input-value="consultPerCustomer[customers[index]] && consultPerCustomer[customers[index]][consult.name] ? 1 : 0 "
                                  @change="onConsultChange(consult, customers[index], $event)"
                                  class="py-0 my-0" />
                              </v-col>
                            </v-row>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-col>
                  </v-row>
                </template>
              </v-container>
              <!--              </v-form>-->
            </v-tab-item>
          </v-tabs>
        </v-form>
        <v-card-actions>
          <v-col cols="8">
            <v-spacer />
            <v-spacer />
            <v-spacer />
            <v-spacer />
          </v-col>
          <v-col cols="4">
            <v-btn
              @click="deleteCustomer()"
              color="grey"
              plain>
              <v-icon>mdi-delete</v-icon>
            </v-btn>
            <v-btn
              @click="submit()"
              :disabled="!form"
              color="primary">
              Сохранить
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>

import {mapState} from 'vuex'

import ReportsMixin from './ReportsMixin'
import CustomersComboBox from '../../base/CustomersComboBox'
// import BaseDatePicker from '../../base/BaseDatePicker'


export default {
  name: "ReportIndicatorsPsychForm",
  components: {CustomersComboBox},
  mixins: [ReportsMixin],
  data () {
    return {
      form: false,
      indate_acd:null,
      vldate_acd:null,
      num_vl_acd:null,
      customers: [''],
      tab: null,
      activeSyringe: 0,
      selectedItem: '',
      items: [],
      notSyringes: [],
      syringes: [],
      consultancies: [],
      directions: [],
      customerGroups: [],
      toRename: [],
      customerOld: [],
      tests: [],
      consultPerCustomer: {},
      errorMessages: '',
      results: [{text: 'Отрицательный', value: 0}, {text: 'Положительный', value: 1}],
      results_prev: [{text: 'Неизвестно', value: 998}, {text: 'Отрицательный', value: 0}, {
        text: 'Положительный',
        value: 1
      }, {text: 'Отказ от ответа', value: 997}],
      education: [{text: 'Неизвестно', value: 0}, {text: 'Неполное среднее', value: 1}, {
        text: 'Среднее',
        value: 2
      }, {text: 'Среднее специальное', value: 3},
        {text: 'Неполное высшее', value: 4}, {text: 'Высшее', value: 5}],
      treatment: [{text: 'Не знаю', value: 998}, {text: 'Да', value: 1}, {text: 'Нет', value: 0}],
      customerEducation: 0,
      customerTreatment: 998
    }
  },
  computed: {
    ...mapState({
      customersInReport: state => state.newOutreachReports.customers,
      productsList: state => state.tableData.products,
      customerGroupsList: state => state.tableData.customerGroups,
      testsList: state => state.tableData.tests,
      directionsList: state => state.tableData.directions,
      consultingsList: state => state.tableData.consultings
    }),
    // consultListItems: {
    //   get () {
    //     let items = this.consultListFiltered.map(p => ({'text':p.name,'value':p.id,'name':p.name,'id':p.id,'field_type':p.field_type}))
    //     this.consultListSelected = items.map(p => p.value)
    //     return items
    //   },
    //   set (customer) {
    //       //console.log(customer)
    //   }
    // },
    productsGroups () {
      return this.notSyringes.map(item => item.field_group)
          .filter((value, index, self) => self.indexOf(value) === index)
    },
    productsPerGroup () {
      let data = {}
      this.productsGroups.forEach(g => data[g] = this.notSyringes.filter(v => v.field_group === g))
      return data
    },
    allSyringes () {
      return this.syringes.reduce((accumulator, syringeType) => {
        return accumulator + parseInt(syringeType.amount)
      }, 0)
    },
    nonZeroProducts () {
      let nonZeroProducts = [],
          nonZeroSyringes = this.syringes.filter(product => product.amount > 0),
          nonZeroNotSyringes = this.notSyringes.filter(product => product.amount > 0),
          nonTests = this.testsListItems.filter(product => product.result.result !== null),
          nonConsults = this.consultListItems.filter(product => product.amount > 0)
      nonZeroProducts = nonZeroProducts.concat(nonZeroSyringes, nonZeroNotSyringes, nonConsults, nonTests)
      return nonZeroProducts
    }
  },
  created () {
    if ('customers' in this.$route.params) {
         if (Object.entries(this.$route.params.customers).length > 0)  {
                this.$route.params.customers.forEach(v => {
                  // this.consultPerCustomer[v['code']]=v['consultings']
                  this.consultPerCustomer[v['code']]=Object.assign({}, ...v['consultings'].map((x) => {
                      let nDict = {...x,...{'amount':1}}
                      return  {[x.name]: nDict}
                    }))

                })

                this.customers = this.$route.params.customers.map(v => v.code)
    }
    }

  },
  methods: {
    onConsultChange (consult, customer, val) {
      //console.log('changes', consult, customer, val)
      if (Object.entries(this.consultPerCustomer).length === 0 && this.consultPerCustomer.constructor === Object)  {
        this.consultPerCustomer[customer] = {...this.consultPerCustomer[customer], ...{[consult.name]: {'id':consult.value,'name':consult.name,'amount':consult.amount}}}

      } else {

        if (val===1) {
                      this.consultPerCustomer[customer] = {...this.consultPerCustomer[customer], ...{[consult.name]: {'id':consult.value,'name':consult.name,'amount':val}}}
        }
        else {
          this.consultPerCustomer[customer] = Object.fromEntries(Object.entries(this.consultPerCustomer[customer]).filter(([key]) => key!==consult.name))
        }
      }
      //console.log(this.consultPerCustomer)
    },
    prepareService (listItems, customer, type) {
      return listItems.map(service => {
        service.amount = this.findServiceVolume(customer, service, type)
        let params = this.findServiceParams(customer, service, type)
        service.id = params.id
        service.products_id = params.products_id
        service.consultations_id = params.consultations_id
        service.directions_id = params.directions_id
        service.customers_id = params.customers_id
        service.redcap_repeat_instance = params.redcap_repeat_instance
        return service
      })
    },
    addActiveSyringe () {
      if (this.syringes[this.activeSyringe].amount < (24 + this.syringes[this.activeSyringe].step))
        this.syringes[this.activeSyringe].amount += this.syringes[this.activeSyringe].step
    },
    removeActiveSyringe () {
      if (this.syringes[this.activeSyringe].amount >= 0 + this.syringes[this.activeSyringe].step)
        this.syringes[this.activeSyringe].amount -= this.syringes[this.activeSyringe].step
    },
    addCustomer () {
      this.customers.push('')
      this.$nextTick(() => {
        this.$refs['combo-' + (this.customers.length - 1)][0].$children[0].focus()
        this.$refs['panel-'+(this.customers.length - 1)][0].toggle()

      })
    },
    setInDate () {

    },
    setVlDate () {

    },
    onClear (idx) {
      if (this.customers.length > 1) {
        let nexCustomers = this.customers.filter((customer, index) => index !== idx)
        this.customers = []
        this.$nextTick(() => {
          this.customers = nexCustomers
        })
      }
    },
    getButtonColor (id) {
      let activeProduct = this.notSyringes.find(product => product.value === id)
      return activeProduct.amount > 0 ? 'primary' : ''
    },
    deleteCustomer () {
      // let route = this.reportType === 'outreach' ? 'ReportOutreachList' : 'ReportCaseList'
      let vm = this
      let route = this.reportTypeRoute + 'List'
      this.$store.commit("newOutreachReports/deleteCustomer", vm.$route.params.customerId)
      this.$router.push({name: route, params: {reportId: this.reportId}})
    },
    submit () {
      if (this.validate()) {
      // if (1===1) {
        let route = this.reportTypeRoute + 'List'
        let vm = this
        Object.entries(this.consultPerCustomer).forEach(([cust, consult]) => {
              vm.$store.dispatch("newOutreachReports/addCustomers", {
                customers: [cust],
                consultings: Object.values(consult),
                reportType: vm.reportType
              })
              }
        )
        vm.$store.dispatch("newOutreachReports/saveReport", {
          reportId: vm.$store.state.newOutreachReports.id,
          type: vm.reportType,
          toRename: vm.toRename,
          codes: this.customers
        }).then((response) => {
          //console.log('id', vm.$store.state.newOutreachReports.id)
        })
          //console.log('id', vm.$store.state.newOutreachReports.id)
         vm.$router.push({name: route, params: {reportId: vm.$store.state.newOutreachReports.id, lastEdited: this.customers[0]}})
      } else {
        this.$vuetify.goTo('.error--text', {offset: 100})
      }
    },

    validate () {
      return this.$refs.form.validate()
    },
    findServiceVolume (customer, serviceData, type) {
      if (!customer) return 0
      let services = [...customer.products]
      let cond = 'products_id'
      if (type === 'direct') {
        services = [...customer.directions]
        cond = 'directions_id'
      } else if (type === 'consult') {
        services = [...customer.consultings]
        cond = 'consultations_id'
      }
      // let services = [...customer.consultings, ...customer.products, ...customer.tests]
      let serviceId = serviceData['value']

      const service = services.find(clientsService => clientsService[cond] === serviceId)

      return service ? type ? 1 : service.amount : 0
    },

    findServiceParams (customer, serviceData, type) {
      if (!customer) return 0
      let services = [...customer.products]
      let cond = 'products_id'
      if (type === 'direct') {
        services = [...customer.directions]
        cond = 'directions_id'
      } else if (type === 'consult') {
        services = [...customer.consultings]
        cond = 'consultations_id'
      }
      let serviceId = serviceData['value']
      const service = services.find(clientsService => clientsService[cond] === serviceId)
      if (!service) {
        return {
          'id': null,
          'products_id': serviceId,
          'customers_id': null,
          'redcap_repeat_instance': null,
          'consultations_id': null,
          'directions_id': null
        }
      }

      return {
        'id': service.id,
        'products_id': service.products_id,
        'customers_id': service.customers_id,
        'redcap_repeat_instance': service.redcap_repeat_instance,
        'consultations_id': service.consultations_id,
        'directions_id': service.directions_id
      }
    },
    findTestParams (customer, serviceId) {
      if (!customer) return 0
      let services = [...customer.tests]
      const service = services.find(clientsService => clientsService.tests_id === serviceId)
      if (!service) {
        return {
          'id': null, 'tests_id': serviceId, 'customers_id': customer.id, 'redcap_repeat_instance': null,
          'result': {
            'is_tested': false,
            'is_positive': false,
            'link_id': null,
            'id': null,
            'result': null,
            'result_prev': null
          }, 'diseasetype': {'name': null, 'id': null}
        }
      }

      return {
        'id': service.id, 'tests_id': service.tests_id, 'customers_id': service.customers_id,
        'redcap_repeat_instance': service.redcap_repeat_instance,
        'result': service.result, 'diseasetype': service.diseasetype
      }
    },
    ticksLabels (step) {
      let res = []
      for (let i = 0; i <= 30; i++) {
        if (i % step === 0) {
          res.push(i)
        }
      }
      return res
    },
    checkCustomerDuplicates (customer) {
      return this.$route.params.customerId === customer || !this.customersInReport.some(reportCustomer => {
        return reportCustomer.code === customer
      }) || 'Клиент повторяется'
    }
  }
}
</script>
<style lang="scss">
.report-slider .v-slide-group__prev, .report-slider .v-slide-group__next {
  display: none !important;
}

.shr-button {
  max-width: 100%;

  span {
    max-width: 100%;
    text-align: left;
    display: inline;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.content {
  max-width: 800px;
}

.overflow-visible {
  overflow: visible !important;
}

.red-text {
  background-color: red !important;
  border-color: red !important;
}
.divider {
		border-bottom: 1px solid #FFF;
		background-color: #DADADA;
		//height: 1px;
		margin: 0.5em 0px 1.5em;
}

.divider span {
		display: block;
		width: auto;
		//height: 1px;
		background-color: #DADADA;
}

</style>



// WEBPACK FOOTER //
// src/components/reports/new/ReportIndicatorsPsychForm.vue